const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export class CookieHelper {
  private isBrowser: boolean;

  constructor() {
    this.isBrowser = typeof window !== 'undefined';
  }

  public isString(testString: string): boolean {
    return typeof testString === 'string';
  }

  public getCookie(cookieName: string): string {
    if (!this.isBrowser) return '';

    try {
      const cookieArray = decodeURIComponent(document.cookie)
        .split(';')
        .filter(cookie => {
          const splitCookie = cookie.split('=');

          return splitCookie[0].indexOf(cookieName) !== -1;
        });

      if (cookieArray.length > 0) {
        return cookieArray.shift()?.split('=').pop() || '';
      }

      return '';
    } catch (e) {
      return '';
    }
  }

  public getCookieFromPreferedSource(cookieName: string): string {
    return this.getCookie(cookieName);
  }

  public setBrowserCookie(cookieName: string, value: string, expiry: number): void {
    const config = `; expires=${new Date(expiry).toUTCString()} ; path=/;`;
    document.cookie = `${cookieName}=${encodeURIComponent(value)}${config}`;
  }
}

export interface ICookieService {
  cookieName: string;
  cookieValue: string;
  getArray(): Array<any>;

  getString(): string;
  helper: CookieHelper;
  select(cookieName: string): CookieService;
  set(valueString?: string, expiry?: number): void;
  setArrayString(cookieBetIdArray: Array<any>, divider?: string, divider2?: string): string;
}

export class CookieService implements ICookieService {
  cookieValue: string;
  cookieName: string;
  helper: CookieHelper;

  constructor() {
    this.cookieName = '';
    this.cookieValue = '';
    this.helper = new CookieHelper();
  }

  public select(cookieName: string) {
    if (this.helper.isString(cookieName)) {
      this.cookieName = cookieName;
    } else {
      throw 'Cookie name is not a string';
    }

    return this;
  }

  public getString(): string {
    this.cookieValue = this.helper.getCookieFromPreferedSource(this.cookieName);

    if (this.cookieValue !== null) {
      return this.cookieValue;
    }
    return '';
  }

  public getArray(divider = ',', transform?: (T: any) => Array<typeof T>): Array<any> {
    this.cookieValue = this.helper.getCookieFromPreferedSource(this.cookieName);

    if (this.cookieValue !== null) {
      const val = this.cookieValue.split(divider);

      if (transform) {
        return val.map(transform);
      }
      return val;
    }
    return [];
  }

  public setArrayString(cookieBetIdArray: Array<any>, divider = ',', divider2 = '~'): string {
    const cookieString = cookieBetIdArray.map(id => id.join(divider2)).join(divider);

    const expiry = new Date().getTime() + ONE_DAY_MS;

    this.select(this.cookieName).set(cookieString, expiry);

    return cookieString;
  }

  public set(valueString = '', expiry = 0): void {
    if (typeof window !== 'undefined') {
      this.helper.setBrowserCookie(this.cookieName, valueString, expiry);
    }
  }
}
